<template>
  <div>
    <Header></Header>
    <main>
      <div class="section section-alpha">
        <div class="container">
          <h1>Participant information</h1>
        </div>
      </div>
      <Info></Info>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Info from "@/components/Info.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Header,
    Info,
    Footer
  }
};
</script>
